<template>
  <sweet-modal
    ref="modal"
    class="vld-parent"
    hide-close-button
    @close="closeModal"
  >
    <loading :active="savingTemplate" :is-full-page="false" />

    <p>
      <StrongI18n
        keypath="modals.delete_template"
        :values="{propName: selectedTemplate.name}"
      />
    </p>

    <template #button>
      <button class="btn btn-default right-margin" @click="close">
        {{ $t('modals.close_button') }}
      </button>
      <button class="btn btn-danger" @click="remove">
        {{ $t('template.delete') }}
      </button>
    </template>
  </sweet-modal>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex';
import {SweetModal} from 'sweet-modal-vue-3';
import Loading from 'vue-loading-overlay';
import StrongI18n from '../lang/StrongI18n.vue';

export default {
  name: 'DeleteTemplateModal',
  components: {
    SweetModal,
    Loading,
    StrongI18n
  },
  data() {
    return {
      selectedTemplate: {}
    };
  },
  computed: {
    ...mapState({
      savingTemplate: state => state.savingTemplate,
      success: state => state.success
    })
  },
  methods: {
    ...mapActions(['deleteTemplate']),
    ...mapMutations(['setSuccess']),
    open(template) {
      this.selectedTemplate = template;
      this.setSuccess(false);
      this.$refs.modal.open();
    },
    closeModal() {
      this.selectedTemplate = {};
    },
    remove() {
      this.deleteTemplate(this.selectedTemplate);
    },
    close() {
      this.$refs.modal.close();
    }
  },
  watch: {
    success(newVal) {
      if (newVal === true) {
        this.$refs.modal.close();
      }
    }
  }
};
</script>

<style scoped>
.right-margin {
  margin-right: 1em;
}
</style>
